import { render, staticRenderFns } from "./RatingQuestionComponent.vue?vue&type=template&id=f3de62e8&"
import script from "./RatingQuestionComponent.vue?vue&type=script&lang=js&"
export * from "./RatingQuestionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports